var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var callbacks = [];
var pending = false;
var timerFunc;
if (typeof Promise !== 'undefined') {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
    };
}
else if (typeof MutationObserver !== 'undefined' && MutationObserver.toString() === '[object MutationObserverConstructor]') {
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
}
else {
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var _i = 0, copies_1 = copies; _i < copies_1.length; _i++) {
        var func = copies_1[_i];
        func();
    }
}
export function nextTick(cb, ctx) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call.apply(cb, __spreadArray([ctx], args, false));
            }
            catch (e) {
                console.error(e);
            }
        }
        else if (_resolve) {
            _resolve(args);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    if (!cb && typeof Promise !== 'undefined') {
        new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}
